import { TECH_FORM_VALIDATION_CONFIG } from "../models/tech-form-validation.constants";
import type { TableRow } from "../models/tq3-draft.models";

export function prepareDraftRowsForEditing(value: unknown): TableRow[] {
  const rows = Array.isArray(value) ? (value.map((row) => ({ ...row })) as TableRow[]) : [];
  const retained = rows.filter(
    (row, index) =>
      index < TECH_FORM_VALIDATION_CONFIG.draftCount ||
      [row.draft, row.dwt, row.tpc].some((cell) => String(cell ?? "").trim() !== ""),
  );
  while (retained.length < TECH_FORM_VALIDATION_CONFIG.draftCount) {
    retained.push({ id: Math.max(0, ...retained.map((row) => Number(row.id) || 0)) + 1, draft: "", dwt: "", tpc: "" });
  }
  return retained;
}
